export default __webpack_public_path__ + "static/media/hero-hand.1e74a719.svg";